import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { SKIP_SPINNER, SpinnerService } from 'src/app/services/spinner.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  private excludedUrls: string[] = [
    '/core/resident/get/details?residentId=',
    'core/mailbox/view?fileKey=',
    '/core/community/verify/charge-code',
    'core/notification/read?notificationId=',
    'core/notification/user/count',
    'core/policy/validate-policy',
    'core/community/charge-day',
    'core/file/view?fileKey=',
  ];

  constructor(private spinner: SpinnerService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const shouldExclude =
      request.context.get(SKIP_SPINNER) ||
      this.excludedUrls.some((url) => request.url.includes(url));
    if (!shouldExclude) {
      this.spinner.show();
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (!shouldExclude) {
          this.spinner.hide();
        }
      }),
    );
  }
}
